import React from 'react';

const PageTitle = ({ children, className = '', id, style }) => {
  return React.createElement(
    'h1',
    {
      className,
      id,
      style,
    },
    children,
  );
};

export default PageTitle;